import { Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import GetUserPermissions from '../../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../../Constants/Permissions'
import BulkActionsMoviesList from '../BulkActionsMoviesList'
import FliterOptions from './FliterOptions'
import SearchFilter from './SearchFilter'
import TableChildMovieList from './TableChildMovieList'

export default function SearchFilterActionsTable(props) {
  const {
    setDropDownsDisable,
    SetsearchDisableOnDropDownSelect,
    disableInputOnDropDownSelect,
    setOnSearchingFilterDropDownsDisable,
    setTotalRenderedCount,
    setFromValue,
    searchedValue,
    setSearchedValue,
    filterBYSearch,
    setLoadMore,
    getListMoviesData,
    setServiceData,
    searchDisableOnDropDownSelect,
    onSearchingFilterDropDownsDisable,
    DropDownsDisable,
    filterDisable,
    resetButton,
    filterButton,
    movieAndPersonValue,
    UserAndEditValue,
    dropDownMovieAndPerson,
    dropDownUserAndEdit,
    status,
    setStatus,
    handleDeleteClick,
    loggedInUserHandle,
    checkSelectedArrayLength,
    setCheckBoxArr,
    serviceData,
    checkBoxArr,
    isLoading,
    loadMoreData,
    loadMore,
    checkboxfunction,
    SetFilterValue,
  } = props
  const [ApproveOptionBoolean, setApproveOptionBoolean] = useState()
  const [EDitOptionPermission, setEDitOptionPermission] = useState(false)
  const [DeleteOptionPermission, setDeleteOptionPermission] = useState(false)
  const [BulkActionPermission, setBulkActionPermission] = useState(false)
  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = { mobileNumber: Auth.user.attributes.phone_number }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissionsArray =
        userPermissions?.userRolesAndPermissions?.reduce(
          (flattenedPermissions, role) => [
            ...flattenedPermissions,
            ...role.permissions.map(permission => permission.name),
          ],
          [],
        ) || []

      setApproveOptionBoolean(permissionsArray.includes(DefinedPermissions.MovieListApprove))

      setEDitOptionPermission(permissionsArray.includes(DefinedPermissions.MovieListEdit))
      setDeleteOptionPermission(permissionsArray.includes(DefinedPermissions.MovieListDelete))
      setBulkActionPermission(permissionsArray.includes(DefinedPermissions.MovieListBulkActions))
    }

    getPermissions()
  }, [])
  return (
    <>
      <SearchFilter
        setDropDownsDisable={setDropDownsDisable}
        SetsearchDisableOnDropDownSelect={SetsearchDisableOnDropDownSelect}
        disableInputOnDropDownSelect={disableInputOnDropDownSelect}
        setOnSearchingFilterDropDownsDisable={setOnSearchingFilterDropDownsDisable}
        setTotalRenderedCount={setTotalRenderedCount}
        setFromValue={setFromValue}
        searchedValue={searchedValue}
        setSearchedValue={setSearchedValue}
        filterBYSearch={filterBYSearch}
        setLoadMore={setLoadMore}
        getListMoviesData={getListMoviesData}
        setServiceData={setServiceData}
        searchDisableOnDropDownSelect={searchDisableOnDropDownSelect}
        onSearchingFilterDropDownsDisable={onSearchingFilterDropDownsDisable}
        status={status}
      />
      <FliterOptions
        DropDownsDisable={DropDownsDisable}
        onSearchingFilterDropDownsDisable={onSearchingFilterDropDownsDisable}
        filterDisable={filterDisable}
        resetButton={resetButton}
        filterButton={filterButton}
        movieAndPersonValue={movieAndPersonValue}
        UserAndEditValue={UserAndEditValue}
        dropDownMovieAndPerson={dropDownMovieAndPerson}
        dropDownUserAndEdit={dropDownUserAndEdit}
        status={status}
        setStatus={setStatus}
        SetFilterValue={SetFilterValue}
        // setFilterDisable={setFilterDisable}
      />
      <BulkActionsMoviesList
        handleDeleteClick={handleDeleteClick}
        loggedInUserHandle={loggedInUserHandle}
        checkSelectedArrayLength={checkSelectedArrayLength}
        setCheckBoxArr={setCheckBoxArr}
        serviceData={serviceData}
        setServiceData={setServiceData}
        checkBoxArr={checkBoxArr}
        status={status}
        BulkActionPermission={BulkActionPermission}
      />
      <TableChildMovieList
        checkBoxArr={checkBoxArr}
        isLoading={isLoading}
        handleDeleteClick={handleDeleteClick}
        loadMoreData={loadMoreData}
        serviceData={serviceData}
        loadMore={loadMore}
        checkboxfunction={checkboxfunction}
        setServiceData={setServiceData}
        status={status}
        ApproveOptionBoolean={ApproveOptionBoolean}
        EDitOptionPermission={EDitOptionPermission}
        DeleteOptionPermission={DeleteOptionPermission}
      />
    </>
  )
}
